import { LassiProfiles } from '../layers';
import { MapEnquiryOption } from '../map';

export interface IMapEnquiryOption {
  id: string;
  htmlTitle?: string; // this will have precedence over the normal title
  title: string;
  description: string;
  iconBackgroundColor: string;
  icon?: string;
  iconColor?: string;
  lassiProfile: LassiProfiles;
  badges: IMapEnquiryBadge[];
}

export interface IMapEnquiryBadge {
  text: string;
  color: string;
}

export const customEnquiryOption: IMapEnquiryOption = {
  id: 'Custom',
  htmlTitle: 'LASSI Custom Enquiry',
  title: 'Custom',
  description: 'Load a saved custom view suited to your workflow',
  iconBackgroundColor: '#EAD4F4',
  lassiProfile: 'Custom',
  badges: [
    {
      text: 'Custom',
      color: '#EAD4F4',
    },
  ],
};

export const enquiryOptions: IMapEnquiryOption[] = [
  {
    id: MapEnquiryOption.PropertyEnquiry.valueOf(),
    htmlTitle: 'LASSI Property Enquiry',
    title: 'Property Enquiry',
    description: 'Find land and property information',
    iconBackgroundColor: '#89d4ff',
    icon: 'home',
    lassiProfile: MapEnquiryOption.PropertyEnquiry,
    badges: [
      {
        text: 'LASSI',
        color: '#89d4ff',
      },
      {
        text: 'SPEAR',
        color: '#89d4ff',
      },
    ],
  },
  {
    id: MapEnquiryOption.VicnamesEnquiry.valueOf(),
    title: 'VICNAMES Enquiry',
    description: 'Search the official Register of geographic names',
    iconBackgroundColor: '#ffe895',
    icon: 'map',
    lassiProfile: MapEnquiryOption.VicnamesEnquiry,
    badges: [
      {
        text: 'VICNAMES',
        color: '#ffe895',
      },
    ],
  },
  {
    id: MapEnquiryOption.SurveyMarkEnquiry.valueOf(),
    htmlTitle: 'SMES Enquiry',
    title: 'Survey Mark Enquiry',
    description: 'Find and update survey mark information',
    iconBackgroundColor: '#9fd9d5',
    icon: 'stars',
    lassiProfile: MapEnquiryOption.SurveyMarkEnquiry,
    badges: [
      {
        text: 'SMES',
        color: '#9fd9d5',
      },
    ],
  },
];
